<template>
  <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.task, collapsed: !expanded.task }">
        <div class="info-card-content">
        <div v-if="!expanded.task">
          <div class="info-row">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                <path d="M9 16C8.00235 16 7.06788 15.8066 6.1966 15.4198C5.32531 15.0331 4.5671 14.5106 3.92195 13.8524C3.2768 13.1942 2.76467 12.4207 2.38556 11.5318C2.00646 10.6429 1.8169 9.68957 1.8169 8.67176C1.8169 7.65394 2.00646 6.70059 2.38556 5.81171C2.76467 4.92282 3.2768 4.14928 3.92195 3.49109C4.5671 2.83291 5.32531 2.31043 6.1966 1.92366C7.06788 1.5369 8.00235 1.34351 9 1.34351C9.99765 1.34351 10.9321 1.5369 11.8034 1.92366C12.6747 2.31043 13.4329 2.83291 14.0781 3.49109C14.7232 4.14928 15.2353 4.92282 15.6144 5.81171C15.9935 6.70059 16.1831 7.65394 16.1831 8.67176C16.1831 9.68957 15.9935 10.6429 15.6144 11.5318C15.2353 12.4207 14.7232 13.1942 14.0781 13.8524C13.4329 14.5106 12.6747 15.0331 11.8034 15.4198C10.9321 15.8066 9.99765 16 9 16ZM11.2347 12.0916L12.3521 10.9517L9.79812 8.34606V4.60051H8.20188V8.99746L11.2347 12.0916ZM3.89202 0L5.00939 1.13995L1.61737 4.60051L0.5 3.46056L3.89202 0ZM14.108 0L17.5 3.46056L16.3826 4.60051L12.9906 1.13995L14.108 0ZM9 14.3715C10.5563 14.3715 11.8766 13.8185 12.9607 12.7125C14.0448 11.6064 14.5869 10.2595 14.5869 8.67176C14.5869 7.08397 14.0448 5.73707 12.9607 4.63104C11.8766 3.52502 10.5563 2.97201 9 2.97201C7.44366 2.97201 6.12344 3.52502 5.03932 4.63104C3.9552 5.73707 3.41315 7.08397 3.41315 8.67176C3.41315 10.2595 3.9552 11.6064 5.03932 12.7125C6.12344 13.8185 7.44366 14.3715 9 14.3715Z" fill="#25B8C2"/>
              </svg>
            </div>
            <p class="info-text-title">Task:</p>
        </div>
        </div>
            <div v-else class="info-card-content-col-group">
                <div class="info-row">
                    <div class="icon-container">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                        <path d="M9 16C8.00235 16 7.06788 15.8066 6.1966 15.4198C5.32531 15.0331 4.5671 14.5106 3.92195 13.8524C3.2768 13.1942 2.76467 12.4207 2.38556 11.5318C2.00646 10.6429 1.8169 9.68957 1.8169 8.67176C1.8169 7.65394 2.00646 6.70059 2.38556 5.81171C2.76467 4.92282 3.2768 4.14928 3.92195 3.49109C4.5671 2.83291 5.32531 2.31043 6.1966 1.92366C7.06788 1.5369 8.00235 1.34351 9 1.34351C9.99765 1.34351 10.9321 1.5369 11.8034 1.92366C12.6747 2.31043 13.4329 2.83291 14.0781 3.49109C14.7232 4.14928 15.2353 4.92282 15.6144 5.81171C15.9935 6.70059 16.1831 7.65394 16.1831 8.67176C16.1831 9.68957 15.9935 10.6429 15.6144 11.5318C15.2353 12.4207 14.7232 13.1942 14.0781 13.8524C13.4329 14.5106 12.6747 15.0331 11.8034 15.4198C10.9321 15.8066 9.99765 16 9 16ZM11.2347 12.0916L12.3521 10.9517L9.79812 8.34606V4.60051H8.20188V8.99746L11.2347 12.0916ZM3.89202 0L5.00939 1.13995L1.61737 4.60051L0.5 3.46056L3.89202 0ZM14.108 0L17.5 3.46056L16.3826 4.60051L12.9906 1.13995L14.108 0ZM9 14.3715C10.5563 14.3715 11.8766 13.8185 12.9607 12.7125C14.0448 11.6064 14.5869 10.2595 14.5869 8.67176C14.5869 7.08397 14.0448 5.73707 12.9607 4.63104C11.8766 3.52502 10.5563 2.97201 9 2.97201C7.44366 2.97201 6.12344 3.52502 5.03932 4.63104C3.9552 5.73707 3.41315 7.08397 3.41315 8.67176C3.41315 10.2595 3.9552 11.6064 5.03932 12.7125C6.12344 13.8185 7.44366 14.3715 9 14.3715Z" fill="#25B8C2"/>
                      </svg>
                    </div>
                </div>
                <div>
                  <div v-if="taskData.primaryTask">
                    <p class="info-text-title">Task:</p>
                    <p class="info-text mb-2 mt-1">{{ taskData.primaryTask.title }}</p>
                    <p class="info-text-title">Due Date:</p>
                    <p class="info-text mb-2">{{ formatDate(taskData.primaryTask.start_date || taskData.primaryTask.due_date) }}</p>
                    <p class="info-text-title">Status:</p>
                    <p class="info-text">{{ taskData.primaryTask.is_completed ? 'Completed' : 'Pending' }}</p>
                  </div>
                  <div v-else>
                    <p class="info-text mb-2 mt-1">No tasks assigned</p>
                    <p class="info-text-title">Status:</p>
                    <p class="info-text">N/A</p>
                  </div>
              </div>
            </div>
            <div v-if="expanded.task" class="action-icons">
              <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
                <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
              </div>
              <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
                <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
              </div>
              <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('task')">
                <img src="@/assets/cardActions/collapse.svg" alt="Expand" />
              </div>
            </div>
            <div v-else class="flex flex-row items-center gap-2">
              <div class="action-icon" @click.stop="toggleCard('task')">
                <img src="@/assets/cardActions/expand.svg" alt="Collapse" />
              </div>
              <div class="drag-handle action-icon">
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </div>
            </div>
          </div>
          <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
            <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
              <template #prefix>
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </template>
            </FoldableButton>
          <div class="flex flex-row gap-1 justify-end">
            <FoldableButton text="Edit" @click="handleEditTask">
              <template #prefix>
                <img src="@/assets/cardActions/edit.svg" alt="Edit" />
              </template>
            </FoldableButton>
          </div>
        </div>
    </div>
</transition>

</template>
<script setup>
import { ref, computed } from 'vue';
import { useCardActions } from '@/composables/useCardActions';
import { useMyPatientsStore } from '@/store/helpers';

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  task: {
    type: Object,
    default: () => ({})
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  context: {
    type: String,
    default: 'card' // 'card' for tabs or 'pegboard' for pegboard
  }
})

// Define emits
const emit = defineEmits(['unpin-card', 'pin-card', 'edit-task']);

const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

const { patientInfoStore } = useMyPatientsStore();


const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};
;

// This is called after the leave animation finishes
const afterLeave = () => {
  // For tab cards, find card_id using getPegboardCardId
  let cardDataToUnpin = props.cardData;
  if (props.context === 'card' && taskData.value?.primaryTask?.task_id) {
    const cardData = {
      category: 'Calendar',
      entity_type: 'task',
      entity_id: String(taskData.value.primaryTask.task_id)
    };
    const cardId = patientInfoStore.getters.getPegboardCardId(cardData);
    if (cardId) {
      cardDataToUnpin = { ...cardData, id: cardId };
    }
  }
  emit('unpin-card', cardDataToUnpin);
};



const expanded = ref({
    task: true,
})

const toggleCard = (cardType) => {
    expanded.value[cardType] = !expanded.value[cardType]
}

// Handle edit task click
const handleEditTask = () => {
  const task = taskData.value?.primaryTask
  if (task) {
    emit('edit-task', task)
  }
}

// Format date for display
const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A'
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

// Get task data directly from store - returns task object or null
const taskData = computed(() => {
  // For tab cards: use task prop directly
  if (props.task && props.context === 'card') {
    return {
      totalTasks: 1,
      allTasks: [props.task],
      primaryTask: props.task
    }
  }

  // For pegboard cards: fetch from store using entity_id
  if (props.cardData?.entity_id) {
    const tasks = patientInfoStore.state.currentPatientTasks.value || []
    const numericTaskId = Number(props.cardData.entity_id)
    const task = tasks.find(t => 
      t.task_id === numericTaskId || 
      t.id === numericTaskId
    )
    
    if (task) {
      return {
        totalTasks: 1,
        allTasks: [task],
        primaryTask: task
      }
    }
  }

  // Fallback: Get from store using current patient ID
  try {
    const result = patientInfoStore.getters.getTaskCardData?.value;
    if (result) {
      return result;
    }
  } catch (error) {
    console.error('Error accessing getTaskCardData getter:', error);
  }

  // Fallback to empty state
  return {
    totalTasks: 0,
    allTasks: [],
    primaryTask: null
  }
})


</script>


<style scoped>

.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
}

.peg-board-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  padding: 0 8px;
}

.info-card {
  background-color: white;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.info-card-content-col-group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.info-row-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-container {
  background-color: #f2f2f2;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-style {
  width: 20px;
  height: 20px;
}

.info-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
}

.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.appointment-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 64px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
  overflow: hidden;
}

.month {
  background-color: #004879;
  color: white;
  width: 100%;
  text-align: center;
  padding: 2px 0;
  font-size: 14px;
}

.day {
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  text-transform: capitalize;
  height: 24px;
}

.weekday {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1;
  padding-bottom: 3px;
}

.appointment-details {
    flex-grow: 1;
}

.detail-title {
    font-size: 12px;
    color: #666;
}
.detail-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}
.action-icons-appointment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 20px;
}
.info-text-title {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #666;
}
.info-text-large {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

/* Badge for billing preference */
.badge {
  color: #25B8C2;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.badge-default {
  border-radius: 20px;
  background: #EBFFF8;
  width: 68px;
}


/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}

.expand-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1B79A0;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
}

.expand-action span {
  color: var(--color-Darkblue-000, #1E4670);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

/* Icon-only buttons with hover text reveal */
.edit-expand,
.move-expand {
  display: flex;
  align-items: center;
  width: 26px;
  overflow: hidden;
  padding: 4px;
  justify-content: center;
  transition: width 0.25s ease, padding 0.25s ease, gap 0.25s ease;
  gap: 0;
}

.edit-expand:hover,
.move-expand:hover {
  padding: 4px 10px;
  justify-content: flex-start;
  gap: 6px;
}

.edit-expand:hover { width: 74px; }
.move-expand:hover { width: 78px; }

.edit-expand span,
.move-expand span {
  white-space: nowrap;
  opacity: 0;
  min-width: 0;
  transition: opacity 0.2s ease;
  transition-delay: 0.05s;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1E4670;
  text-decoration: underline;
}

.edit-expand:hover span,
.move-expand:hover span {
  opacity: 1;
}

.edit-expand img,
.move-expand img {
  flex-shrink: 0;
}

.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover, 
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}

/* unified pin toggle */
.pin-toggle { position: relative; cursor: pointer; }
.pin-toggle .icon { position: absolute; transition: opacity 0.3s ease, transform 0.3s ease; }
.pin-toggle .unpin { opacity: 0; transform: scale(0.8); }
.pin-toggle:hover .pin { opacity: 0; transform: scale(1); }
.pin-toggle:hover .unpin { opacity: 1; transform: scale(1); }
</style>
